// extracted by mini-css-extract-plugin
var _1 = "MoneyInputControlContent-moduleMoneyInputControlContent__R6RRW";
export { _1 as "MoneyInputControlContent" }
